export default function validate(values, required) {
  let errors = {};

  if (required.comments && !values.comments) {
    errors.comments = 'Comments is required';
  }

  return errors;
}